import React from "react";
import { WsrvImage } from "../Media";
import { EWsrvTransform } from "../../lib";

export interface IExpandingImageWithContentBladeProps {
    sectionClassNames?: string;
    imagePosition?: "left" | "right";
    imageUrl: string;
    lazyImageWrapperClassNames?: string;
    imageClassNames?: string;
    contentColClassNames?: string;
    contentBoxClassNames?: string;
    children?: React.ReactNode;
}

export const ExpandingImageWithContentBlade: React.FC<IExpandingImageWithContentBladeProps> = ({
    sectionClassNames = "",
    imagePosition = "left",
    imageUrl,
    lazyImageWrapperClassNames = "",
    imageClassNames = "",
    contentColClassNames = "",
    contentBoxClassNames = "",
    children
}) => {
    return (
        <section className={`flex flex-wrap w-full ${sectionClassNames}`}>
            <WsrvImage
                urlParams={{
                    originURL: imageUrl,
                    preset: EWsrvTransform.fit3x2
                }}
                imgProps={{
                    wrapperClassName: `self-center w-full lg:w-3/5 ${imagePosition === "right" ? "lg:order-last" : ""} ${lazyImageWrapperClassNames}`,
                    className: imageClassNames,
                }}
            />
            <div className={`w-full lg:w-2/5 ${contentColClassNames}`}>
                <div className={`w-full lg:max-w-xl py-11 px-2 ${imagePosition === "left" ? "lg:pl-10 lg:text-right" : "lg:pr-10 ml-auto"} ${contentBoxClassNames}`}>
                    {children}
                </div>
            </div>
        </section>
    )
}

export default ExpandingImageWithContentBlade